import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { Locale } from 'signup-ui-lego-core/constants/Locale';
import styled from 'styled-components';
import { isOAuthSignup } from '../app/verificationTypeSelectors';
import { isOnIndustryStepAndCredentialVerifiedNewUser } from '../google-authentication/google-prompt/googlePromptUtils';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { getApplicationLocale } from '../i18n/LocaleUtils';
import { Data } from '../signup-data/DATA';
import { useSignupData } from '../signup-data/useSignupData';
import { getIsOAuthExistingUser, getIsVerifiedByGoogleCredential } from '../store/app/selectors';
import { getPreviousStep } from '../store/flow/selectors';
import { devices } from '../styles/viewports.styles';
import { Step } from '../views/Step';
import { getStepConfig } from '../views/getStepConfig';
import { StepSubtitle } from './StepSubtitle';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
export const PretitlePlaceHolder = styled.div.withConfig({
  displayName: "GreetingsPretitle__PretitlePlaceHolder",
  componentId: "lij7l5-0"
})(["height:43.5px;", ""], props => props.showMessagingAboveContent && `
    height: 0;

    @media ${devices.tablet} {
      height: 43.5px;
    }

  `);
export const GreetingsPretitle = ({
  hasPreTitle
}) => {
  const {
    data: firstName
  } = useSignupData(Data.FirstName);
  const {
    data: lastName
  } = useSignupData(Data.LastName);
  const previousStep = useSelector(getPreviousStep);
  const locale = getApplicationLocale();
  const isJapanese = locale === Locale.ja;
  const {
    currentStep
  } = useCurrentStep();
  const isGoogleCredentialAuthentication = useSelector(getIsVerifiedByGoogleCredential);
  const isExistingOAuthUser = useSelector(getIsOAuthExistingUser);
  const hasSelectedOAuthSignup = useSelector(isOAuthSignup);
  const hasJustSubmittedName = previousStep === Step.Name || previousStep === Step.LandingPage && hasSelectedOAuthSignup;
  const {
    shouldUseLayoutTemplate
  } = useLayoutTemplate();
  const stepConfig = getStepConfig(currentStep);
  const showMessagingAboveContent = stepConfig && stepConfig.showMessagingAboveContent;
  const {
    isAssignedToSpecificVariant: isAssignedToVariantBACQ0134
  } = useExperiment(ExperimentKeys.ACQ0134, TrackWhen.never);

  const renderNiceToMeetYouSubtitle = () => {
    return /*#__PURE__*/_jsx(StepSubtitle, {
      message: `views.nice-to-meet-you`,
      messageOptions: {
        name: isJapanese ? lastName : firstName
      }
    });
  };

  if (isAssignedToVariantBACQ0134(ExperimentParameterGroup.Variant_B)) {
    return !hasPreTitle ? /*#__PURE__*/_jsx(PretitlePlaceHolder, {
      showMessagingAboveContent: showMessagingAboveContent
    }) : null;
  }

  if (isOnIndustryStepAndCredentialVerifiedNewUser(currentStep, isGoogleCredentialAuthentication, isExistingOAuthUser)) {
    return renderNiceToMeetYouSubtitle();
  }

  if (hasJustSubmittedName) {
    return renderNiceToMeetYouSubtitle();
  }

  if (previousStep === Step.ExistingAccounts) {
    return /*#__PURE__*/_jsx(StepSubtitle, {
      message: `views.hi`,
      messageOptions: {
        name: isJapanese ? lastName : firstName
      }
    });
  }

  return shouldUseLayoutTemplate && !hasPreTitle ? /*#__PURE__*/_jsx(PretitlePlaceHolder, {
    showMessagingAboveContent: showMessagingAboveContent
  }) : null;
};